import React from "react";
import Contact from "./Contact/Contact";
import Header from "./Header/Header";
import classes from "./Home.module.css";
import Products from "./Products/Products";
import Reviews from "./Reviews/Reviews";

function Home({ GetHome }) {
  document.title = `Mehribon.uz |  Mehribonshop.uz`;
  return (
    <div className={classes.Home}>
      <Header />
      <Products GetHome={GetHome} />
      <Reviews />
      <Contact />
    </div>
  );
}

export default Home;
